export const convert = () => {
  return {
    base64ToArrayBuffer: base64 => {
      let binaryString = window.atob(base64);
      let length = binaryString.length;
      let bytes = new Uint8Array(length);
      for (let i = 0; i < length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    }
  };
};
